export default __webpack_public_path__ + "static/media/workflow-stage-assessment-icon.bb9d5419.svg";